<template>
  <div id="ToolTipPopOver" :class="'tool-tip-popover-component ttpc no-gutters ' + classNameWrapper">
    <button
      v-b-popover.click.html="popoverMessage"
      aria-label="Show Tooltip"
      :class="'ttpc__button no-focus-outline ' + className"
      :title="popoverTitle"
    >
      ?
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      className: {
        type: String,
        default: ""
      },
      classNameWrapper: {
        type: String,
        default: ""
      },
      popoverMessage: {
        type: String,
        default: "",
      },
      popoverTitle: {
        type: String,
        default: "",
      },
    }
  }
</script>

<style lang="scss">
.ttpc__button{
  display: block;
  width: 20px;
  height: 20px;
  padding-left: 5.5px;
  line-height: 18px;
  border: 1px solid white;
  border-radius: 50%;
  color: white;
  text-align: center;
  text-decoration: none;
  background: #00010e;
  box-shadow: 2px 2px 3px gray;
  font-size: 12px;
  font-weight: bold;
  &:hover{
    background-color: black;
    background-image: linear-gradient(to bottom, black, black);
    background-repeat: repeat-x;
    color: white !important; /* Unable to change color w/o !important */
  }
}

</style>
